define('controllers/mysetting/mod-bussiness.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('ModBussnessInfo', ['$q', '$scope', '$state', 'auiUpload', 'auiDialog', 'OpenUp', 'UserInfo', 'OpenOther',
        'regionService', 'modBussService', 'modUserInfoService', 'bankSelectService',
        'openAddContactor', 'formValidateService', '$filter', 'auiAgreementHelper', '$stateParams',
        '$rootScope', '$timeout', 'tenantsService',
        function ($q, $scope, $state, auiUpload, auiDialog, OpenUp, UserInfo, OpenOther,
                  regionService, modBussService, modUserInfoService,
                  bankSelectService, openAddContactor, formValidateService, $filter, auiAgreementHelper,
                  $stateParams, $rootScope, $timeout, tenantsService) {
            var Model = $scope.Model = {
                developerAttachment: {},
                identityInfo: false,
                operationInfoFlag: false,
                showAgreementFlag: false,
                //是否在加拿大开展业务
                otherTaxsIncluded: 0,
                defaultOtherTaxsIncluded: 0,
                TaxItem:[
                    {
                        taxName:'在GST/HST普通注册机制下注册',
                        placeholder:'请输入在GST/HST普通注册机制下注册的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'在GST/HST简易注册机制下注册',
                        placeholder:'请输入在GST/HST简易注册机制下注册的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'在Québec一般注册机制下注册',
                        placeholder:'请输入在Québec一般注册机制下注册的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'在Québec特殊注册机制下注册',
                        placeholder:'请输入在Québec特殊注册机制下注册的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'在Saskatchewan注册PST',
                        placeholder:'请输入在Saskatchewan注册PST的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'在British Columbia注册PST',
                        placeholder:'请输入在British Columbia注册PST的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'在Manitoba注册RST',
                        placeholder:'请输入在Manitoba注册RST的税号',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },
                    {
                        taxName:'NA',
                        placeholder:'',
                        taxNumber:'',
                        termsIsSelected:false,
                        disabled:true,
                        defaultermsIsSelected:false,
                        isNa:false
                    },

                ],
                newTaxItem:[
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    },
                    {
                        taxNum:''
                    }
                ],
                sceneList: mainCons.modUserinfoConstant.sceneList,
                countrys: [{key: 'CN', value: '中国'}],
                countrys4EN: [{key: 'CN', value: '中国'}],
                serviceStateMsg: '',
                bankAccountPicCN: '',
                bankAccountPicEN: '',
                acctNameAttachmentCN: '',
                acctNameAttachmentEN: '',
                bankAccountPicCNWH: '',
                bankAccountPicENWH: '',
                acctNameAttachmentENWH: '',
                //商户简称
                mercShortName : '',
                defalutMercShortName: '',
                bankInfoCN: {
                    country: {key: "CN", value: '中国'},
                    currency: 'CNY'
                },
                bankInfoEN: {
                    country: {key: "CN", value: '中国'}
                },
                coraccountNameDisable: false,
                bankCNs: [],
                bankENs: sysParamCfg.bankENs, //跨境银行数据源固定
                commerceCertifyStatus: '',
                isChangeRealName: '',
                isSeleteCNTbs: true,
                isCheckedBankCN: false,
                isCheckedBankEN: false,
                isAudting: false,
                isAudtingCN: false,
                isAudtingEN: false,
                showFlag: 1,
                userTaxInfoOld: {},
                taxInfoForSelect: {},
                submbIsGray: true,
                isShowNomatchBranch: false,
                bankAccountPattern: {
                    cn: false,
                    en: false
                },
                merchantServiceIsSelected: false,
                leastMerchantServiceAgree: {},
                IsKC:false,
                userInfo: UserInfo.get(),
                myUserInfo: angular.copy(UserInfo.get()),
                defaultCountrysList: modBussService.getDefaultCountrysList(),
                isPayVerifyBank: false,
                isCheckPayVerifyBank: true,
                contactWithCustomService: window.sysUrlCfg.documentHref.contactWithCustomService,
                contactWithCustomServiceDescribeCN: ['如您选择不到所需的开户银行，请提供开户银行、开户行支行和开户行号，通过<a class="text-link" target="_blank" href="', window.sysUrlCfg.documentHref.contactWithCustomService, '">工单系统</a>反馈问题。'].join(''),
                openAddContactorTips: '如未创建联系人，请先“增加新联系方式”再填写联系人信息。',
                taxTips: '纳税人类型与开发者帐号类型一致。',
                accountTips: '该开户行帐号为贵公司的收款帐号，请确保银行账户名称与“开户名”保持一致。',
                mercShortNameTips:'我们已升级更优质的商户资金结算服务，根据最新商户资金结算服务规定，需要提供您的商户简称信息。',
                videoTips: '建议法人按以下话术录制”法人开户意愿视频“：<br>“我是#公司名称#的法定代表人（或负责人），特此证明本公司申请的商户号为我司真实意愿开立且用于XX业务（或XX服务）。我司现有业务符合法律法规及华为的相关规定。<br>”录制要求：<br>1.请用普通话录制以上视频；<br>2.本视频必须采集到的清晰正面人脸，请务必保持正脸朝向摄像头且不要遮挡面部；<br>3.请避免对录制原始图像和音频进行任何处理（如滤镜、美颜、变音及其他后期效果）；<br>4.支持上传50M以内的适配文件，格式可为avi、wmv、mpeg、mp4、mov、mkv、flv、f4v、m4v、mvb。',
                beneficiariesTips: '根据《中国人民银行关于加强反洗钱客户身份识别有关工作的通知》要求，如果法人不是企业受益人，则需要补充受益人信息。<br>对非自然人客户受益所有人（实控人）的判定标准如下：<br>1．公司的受益所有人按照以下标准依次判定：直接或者间接拥有超过25%公司股权或者表决权的自然人；通过人事、财务等其他方式对公司进行控制的自然人；公司的高级管理人员。<br>2．合伙企业的受益所有人是指拥有超过25%合伙权益的自然人。登记内容为：身份证照片、姓名、身份证号、身份证有效期限、地址。',
                currency_tpl_default_tips: '通常情况，华为以此币种向您出具结算单。若有单签合同，华为以双方合同约定的币种向您出具结算单。',
                branchNumberTips: '银行编号也称为银行代码。（国家）银行代码与国际银行标识符代码（BIC）不同。此外，您还可以向您的银行咨询更多信息。',
                swiftCodeTips: 'swiftcode长度为11个字符，如您的swiftcode是8位字符，请在末尾添加3个大写X<br>swiftcode 包含大写字母和数字',
                accountTypes: mainCons.modUserinfoConstant.accountTypes,
                isShowControllerList: false,
                today: new Date(),
                timeline: '长期有效建议选择2099-12-31',
                controllerAmount: 0,
                accountCurrency: {
                    allCurrencys: [],
                    selectCurrencys: [],
                    showAccountErrorMsg: false,
                    showDefualErrorMsg: false
                },
                taxInfo: {},
                valid: {
                    accountNameCNValid: {
                        isValidSuc: true,
                        isShowValid: false,
                        validMsg: ''
                    }
                },
                branchs: [],
                branchsEN: [],
                contactorInfo: {},
                userID: '',
                agreements: {
                    merchantServiceAgree: {
                        agreeType: '1003',
                    },//商户协议
                    petalsTremServiceAgree: {
                        agreeType: systemParaConf.petalsAgreements.tremPdfConfType
                    },//隐私协议
                    petalsServiceAgree: {
                        agreeType: systemParaConf.petalsAgreements.ServicePdfConfType
                    }//花瓣服务协议
                },
                branchNumbeToNewNameByCountry: mainCons.modUserinfoConstant.branchNumbeToNewNameByCountry
            };
            var oldBankInfoCN = {};
            var oldBankInfoEN = {};
            var oldUserInfo = {};
            var lastSelBank = '';
            var lastSelBankEN = '';
            var lastSelBranch = '';
            var lastSelBranchEN = '';

            var urlTemp;
            var urlTempEN;
            var urlTempAttachmentEN;
            var urlTempAttachmentCN;

            var oldTaxInfo = {};

            var taxType = {0: '个人', 1: '企业'};

            var oldContactor = {};

            var contactorType = ['market', 'finance', 'legal', 'coorperation'];
            //初次加载
            var initController = true;
            //全局函数
            var isInArray = tenantsService.isInArray;
            var getInArray = tenantsService.getInArray;
            var convertBranchs = tenantsService.convertBranchs;
            var payVerifyBank;
            var myPreloadInfo

            //scope里面的函数定义
            $scope.changeCoorperation = changeContract;
            $scope.changeLegal = changeContract;
            $scope.changeFinance = changeContract;
            $scope.changeMarket = changeContract;
            $scope.openAddContactorPage = openAddContactorPage;
            $scope.changeTaxReceiptType = changeTaxReceiptType;
            $scope.changeTaxCity = changeTax;
            $scope.taxNumKeyup = changeTax;
            $scope.registerAddressKeyup = registerAddressKeyup;
            $scope.changeTaxProvince = changeTaxProvince;
            $scope.uploadBankAccountPic = uploadBankAccountPic;
            $scope.uploadBankAccountPicEN = uploadBankAccountPicEN;
            $scope.bankAccountKeyup = changeBankInfoCN;
            $scope.bankAccountKeyupEN = changeBankInfoEN;
            $scope.accountNameKeyup = accountNameKeyup;
            $scope.accountNameKeyupEN = changeBankInfoEN;
            $scope.isGreeOrGray = isGreeOrGray;

            $scope.changeBankCity = changeBankCity;
            $scope.changeBankProvince = changeBankProvince;
            $scope.changeBank = changeBank;
            $scope.changeBank = changeBankEN;
            $scope.changeCountry = changeBankInfoCN;
            $scope.changeCountryEN = changeCountryEN;
            $scope.downLoadAgreement = downLoadAgreement;
            $scope.cancel = cancel;
            $scope.branchSelected = branchSelected;
            $scope.branchSelectedEN = branchSelectedEN;
            $scope.bankBranchFocusOut = bankBranchFocusOut;
            $scope.bankBranchFocusOutEN = bankBranchFocusOutEN;
            $scope.backSelected = backSelected;

            $scope.backSelectedEN = backSelectedEN;
            $scope.bankFocusOut = bankFocusOut;
            $scope.bankFocusOutEN = bankFocusOutEN;
            $scope.clickCheckboxCN = clickCheckboxCN;
            $scope.clickCheckboxEN = clickCheckboxEN;
            $scope.changeCurrencyEn = changeCurrencyEn;
            $scope.setAccountCurrencys = setAccountCurrencys;
            $scope.taxTypes = taxTypes;
            $scope.taxNumInp = taxNumInp;
            $scope.changRadio = changRadio;

            $scope.showSearchDlgCN = showSearchDlg(true);
            $scope.showSearchDlgEN = showSearchDlg(false);

            $scope.clickPayVerifyBank = clickPayVerifyBank;

            $scope.uploadAcctNameAttachment = uploadAcctNameAttachment;
            $scope.changeBankInfoOffSite = changeBankInfoOffSite;
            $scope.checkByServer4Blur = checkByServer4Blur;
            $scope.merchantServiceSelect = merchantServiceSelect;
            $scope.showAgreement = showAgreement;
            $scope.countTaxItems = countTaxItems;
            $scope.greenSubmit = greenSubmit

            function countTaxItems(){
                var count = 0;
                Model.TaxItem.forEach(function (item){
                    if(item.termsIsSelected){
                        count++;
                    }
                })
                if(count === 0){
                    delete Model.taxItemCount;
                }else{
                    Model.taxItemCount = count;
                }
                return count;
            }
            function taxTypes(index){
                if(Model.isAudting) {
                    return
                }
                $scope.bankInfoForm.taxItem.$setDirty(true);


                if(Model.TaxItem[index].taxName == 'NA' && Model.TaxItem[index].termsIsSelected == false){
                    Model.TaxItem.forEach(function (item){
                        item.isNa = true;
                        item.termsIsSelected = false;
                        item.disabled =true;
                        item.taxNumber = '';
                    })
                    Model.newTaxItem.forEach(function (item){
                        item.taxNum = '';
                    })
                    Model.TaxItem[index].isNa = false;
                    Model.TaxItem[index].termsIsSelected = true;
                }else {
                    Model.TaxItem[index].termsIsSelected = !Model.TaxItem[index].termsIsSelected;
                    Model.TaxItem.forEach(function (item){
                        item.isNa = false;
                    })
                    Model.TaxItem[Model.TaxItem.length - 1].termsIsSelected = false
                }
                if(Model.TaxItem[index].termsIsSelected == false){
                    Model.TaxItem[index].disabled =true;
                    Model.TaxItem[index].taxNumber = '';
                    Model.newTaxItem[index].taxNum = '';
                }else {
                    Model.TaxItem[index].disabled =false;
                }
                if(Model.TaxItem[index].defaultermsIsSelected != Model.newTaxItem[index].termsIsSelected){
                    $scope.isTaxChanged = true;
                }else {
                    $scope.isTaxChanged = false;
                }
                isGreeOrGray();

            }
            function taxNumInp(){
                Model.TaxItem.forEach(function (item,i){
                    if(item.termsIsSelected == true){
                            if (Model.newTaxItem[i].taxNum != undefined && Model.newTaxItem[i].taxNum != item.taxNumber && item.defaultermsIsSelected != item.termsIsSelected){
                                $scope.isTaxChanged = true;
                            }else {
                                $scope.isTaxChanged = false;
                            }
                            isGreeOrGray();
                    }
                })
            }
            function changRadio(target){
                if(Model.isAudting){
                    return
                }
                Model.otherTaxsIncluded = target;
                if(Model.otherTaxsIncluded != Model.defaultOtherTaxsIncluded){
                    $scope.isTaxChanged = true;
                }else {
                    $scope.isTaxChanged = false;
                }
                isGreeOrGray();

            }
            //下载协议
            function downLoadAgreement() {
                auiAgreementHelper.viewAndDownloadAgreements([Model.agreements.merchantServiceAgree.agreeType,
                    Model.agreements.petalsServiceAgree.agreeType,
                    Model.agreements.petalsTremServiceAgree.agreeType]);
            }

            if ($state.$current.name == "mysetting.modBussnessInfo") {
                $rootScope.checkState($state).then(function () {
                    UserInfo.updateCache(initBussiness);
                });
            }

            //监听提交事件
            $rootScope.$on('stateChangedEventToBuss', function (event, data) {
                Model.agreements.merchantServiceAgree.isSignedAgree = true;
                Model.merchantServiceIsSelected = false;
            });

            //初始化
            function initBussiness(userInfo) {
                myPreloadInfo = userInfo;
                modBussService.getIsSignAgreement(Model).then(function () {
                    // 查询是否签署过最新支付协议
                    if (myPreloadInfo.verifyRealState == 2) {
                        Model.userType = myPreloadInfo.userType == 2;
                        if ((myPreloadInfo.userType == 2 && !myPreloadInfo.corpAddress) || (!AUI.HDGWCall.getUserInfoValue('teamid') && myPreloadInfo.userType == 1 && !myPreloadInfo.indivAddress)) {
                            if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                                auiDialog.warn('实名信息不完善', '您的实名认证资料中地址信息未完善，请完善后再设置商户信息。', function () {
                                    $rootScope.toSettingUserInfo();
                                });
                            } else {
                                auiDialog.warn('实名信息不完善', '您的实名认证资料中地址信息未完善，请联系帐号持有者（联系人邮箱：' + myPreloadInfo.contactEmail + '）完善后再设置商户信息。', function () {
                                    $rootScope.toSettingUserInfo();
                                });
                            }
                        } else {
                            regionService.setProvince(function (data) {
                                Model.provinces = data;
                                getBussinessInfo().then(function () {
                                    bankInit();
                                    taxInit();
                                    contactorInit();
                                })
                            });
                        }
                    } else {
                        auiDialog.warn('您的实名认证资料在审核中，请审核通过后再设置商户信息。', function () {
                            $rootScope.toSettingUserInfo();
                        });
                    }

                    $scope.bankInfoForm.accountNameEN && $scope.bankInfoForm.accountNameEN.$setDirty();
                })
            }

            function merchantServiceSelect(selected) {
                if (Model.isAudting && Model.isChangeRealName == 1) return;
                Model[selected] = !Model[selected];
                if (Model.merchantServiceIsSelected) {
                    $scope.isAgreementChanged = true;
                    greenSubmit();
                } else {
                    $scope.isAgreementChanged = false;
                }
            }


            function showAgreement(url) {
                // 根据最新的协议版本，查询协议平台，弹框提示签署
                AUI.BaseJSUtil.redirectUrlByBlank(url);
            }

            //获取银行信息
            function getBussinessInfo() {
                var defer = $q.defer();
                modBussService.getExtAttr().then(function (bankWhitelistStatus) {
                    Model.bankWhitelistStatus = bankWhitelistStatus;//0表示不支持离岸
                    modBussService.getBussinesInfo('00011000001001', function (data) {
                        //处理5s的打点
                           if (!data.bankInfoCN) {
                                setTimeout(function () {
                                    hianalytics.trackLink('访问商户服务', 'DPRM3004', '1', {
                                        "eventType": "CET003008",
                                        "sourceCode": "SC000001",
                                        "bizType": "DPRM|商户服务",
                                        "userId": data.userID,
                                        "eventTimestamp": new Date().getTime(),
                                        "objectId":data.userID,
                                        "objectName": '',
                                        "location": '100002',
                                        "action": 'AC000045',
                                    }, 'dprm');
                                }, 5000);
                            }
                        //判断商户简称如何展示
                            if(data){
                                if(data.bankInfoCN && data.bankInfoCN.mercShortName){
                                    $scope.Model.defalutMercShortName = data.bankInfoCN.mercShortName;
                                    $scope.Model.mercShortName = data.bankInfoCN.mercShortName;
                                }else if(data.bankInfoCN && data.bankInfoCN.bankAcctName && data.bankInfoCN.bankAcctName.length < 21){
                                    $scope.Model.mercShortName = data.bankInfoCN.bankAcctName;
                                    //    亮化按钮
                                    greenSubmit();
                                    if(Model.isCheckedBankCN){
                                        $scope.isBankCNChanged = true
                                    }
                                }else if(data.developerInfo && data.developerInfo.realName && data.developerInfo.realName.length < 21){
                                    $scope.Model.mercShortName = data.developerInfo.realName;
                                    //    亮化按钮
                                    greenSubmit();
                                    if(Model.isCheckedBankCN){
                                        $scope.isBankCNChanged = true
                                    }
                                }
                            }
                        modBussService.getMerchantCountryList().then(function (countryList) {
                            //商户已经通过  成员帐号 非法务 没有签协议  提醒他去联系主账户完善信息
                            if (data && data.bankInfoCN && data.bankInfoCN.verifyBankState == 2  && $scope.mainUserID && !$scope.isLegal && (!Model.agreements.petalsTremServiceAgree.isSignedAgree || !Model.agreements.petalsServiceAgree.isSignedAgree)) {
                                auiDialog.warn("协议提醒", "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请联系主帐号或法务查看、签署相关协议。", function () {
                                    $state.go('mysetting.userInfo', {reload: true});
                                    defer.resolve(true);
                                })
                            } else {
                                //查询国家，避免异常
                                var noPassStatusEn = data && data.bankInfoEN && (data.bankInfoEN.verifyBankState === 1 || data.developerInfo.isChangeRealName === 1 || data.bankInfoEN.updateBankState == 1 || data.bankInfoEN.verifyBankState === 3 || data.bankInfoEN.verifyBankState === 0);
                                var country = noPassStatusEn && !((data.bankInfoCN && data.bankInfoCN.verifyBankState === 0) || (data.bankInfoEN && data.bankInfoEN.verifyBankState === 0)) ? (data.bankInfoEN.attributes && angular.fromJson(data.bankInfoEN.attributes).country) : data && data.bankInfoEN && data.bankInfoEN.country;
                                getOffSiteBankRules(country ? country : 'CN', function () {
                                    Model.AllCountrys = angular.copy(countryList);
                                    if (Model.bankWhitelistStatus) {
                                        Model.countrys4EN = countryList;
                                    }
                                    if (data) {
                                        Model.userID = data.userID;
                                        Model.isChangeRealName = data.developerInfo.isChangeRealName;
                                        Model.userTaxInfoOld = data.userTaxInfo || {};
                                        var strController = [];
                                        //将数组里的对象转化成字符串存放在controllerListOld里用于比较用户是否改变了实控人信息
                                        if (data.controllerList && data.controllerList.length > 0) {
                                            data.controllerList.forEach(function (item) {
                                                item.ctfEffectiveDate = $filter('auiDateFormat')(item.ctfEffectiveDate, '+0800');
                                                item.ctfExpireDate = $filter('auiDateFormat')(item.ctfExpireDate, '+0800');
                                                strController.push(JSON.stringify(item));
                                            })

                                        }
                                        Model.controllerList = data.controllerList;
                                        Model.controllerListOld = strController;
                                        Model.bankInfoCN.accountName = data.developerInfo.realName;
                                        if (data.contactInfo) {
                                            modBussService.initSetContactInfo(data.contactInfo, Model, contactorType);
                                            oldContactor = angular.copy(Model.contactorInfo);
                                        }
                                        modBussService.setTipMsg(data, Model);
                                        if (data.bankInfoCN) {
                                            Model.isAudtingCN = true;
                                            Model.isCheckedBankCN = true;
                                            if ((data.bankInfoCN.verifyBankState === 1 || data.developerInfo.isChangeRealName == 1 ||
                                                data.bankInfoCN.updateBankState === 1 || data.bankInfoCN.verifyBankState === 3 || data.bankInfoCN.verifyBankState === 0) && data.bankInfoCN.attributes) {
                                                if(!data.bankInfoCN.attributes || JSON.stringify(data.bankInfoCN.attributes) === '{}' || data.bankInfoCN.attributes === '') {
                                                    Model.bankInfoCN = angular.fromJson(data.bankInfoCN);
                                                }else {
                                                    Model.bankInfoCN = angular.fromJson(data.bankInfoCN.attributes);
                                                }
                                                AUI.BaseJSUtil.copyAttribute(Model.bankInfoCN, data.bankInfoCN, 'verifyBankState');
                                                AUI.BaseJSUtil.copyAttribute(Model.bankInfoCN, data.bankInfoCN, 'updateBankState');
                                                AUI.BaseJSUtil.copyAttribute(Model.bankInfoCN, data.bankInfoCN, 'verifyBankDesc');
                                            } else {
                                                Model.bankInfoCN = angular.fromJson(data.bankInfoCN);
                                            }
                                            //银行信息只要在审核中，就不能再次提交银行信息
                                            if (data.bankInfoCN.verifyBankState === 1 || data.bankInfoCN.updateBankState === 1) {
                                                Model.isAudting = true;
                                                if(!data.bankInfoCN.attributes || JSON.stringify(data.bankInfoCN.attributes) === '{}' || data.bankInfoCN.attributes === '') {
                                                    Model.bankInfoCN = angular.fromJson(data.bankInfoCN);
                                                }else {
                                                    Model.bankInfoCN = angular.fromJson(data.bankInfoCN.attributes);
                                                }
                                                Model.mercShortName = Model.bankInfoCN.mercShortName;
                                                graySubmit();
                                            }
                                        }
                                        if(data.developerAttachment) {
                                            Model.developerAttachment = data.developerAttachment
                                        }
                                        if (data.bankInfoEN) {
                                            Model.isAudtingEN = true;
                                            Model.isCheckedBankEN = true;
                                            if (noPassStatusEn && data.bankInfoEN.attributes) {
                                                Model.bankInfoEN = angular.fromJson(data.bankInfoEN.attributes);
                                                AUI.BaseJSUtil.copyAttribute(Model.bankInfoEN, data.bankInfoEN, 'verifyBankState');
                                                AUI.BaseJSUtil.copyAttribute(Model.bankInfoEN, data.bankInfoEN, 'updateBankState');
                                                AUI.BaseJSUtil.copyAttribute(Model.bankInfoEN, data.bankInfoEN, 'verifyBankDesc');
                                            } else {
                                                Model.bankInfoEN = angular.fromJson(data.bankInfoEN);
                                            }
                                            //银行信息只要在审核中，就不能再次提交银行信息
                                            if (data.bankInfoEN.verifyBankState === 1 || data.bankInfoEN.updateBankState == 1) {
                                                Model.isAudting = true;
                                            }
                                            fetchBankList();
                                            //处理禁用的字段
                                            setState4Init(Model.bankInfoEN);
                                            //iban特殊处理,去掉2位国家简码
                                            getIban4Init(Model.bankInfoEN);
                                        }
                                        //说明是重新实名认证的并且是提交过银行的
                                        if ((data.bankInfoCN && data.bankInfoCN.verifyBankState === 0) || (data.bankInfoEN && data.bankInfoEN.verifyBankState === 0)) {
                                            Model.isReVer = true;
                                            Model.submbIsGray = false;
                                            $scope.doSubmit = doSummit;
                                        }
                                        renderBankData(data.developerInfo);
                                        oldUserInfo = angular.copy(data.developerInfo);
                                        Model.incorDeveloper = data.indivDeveloper || data.corpDeveloper;
                                        renderTaxData(data.developerInfo, data.userTaxInfo);
                                        modBussService.getPayVerifyBank().then(function (resp) {
                                            payVerifyBank = angular.fromJson(resp);
                                            if (!data.bankInfoCN && myPreloadInfo.verifyType == 3 && (payVerifyBank.bankAcctName == data.developerInfo.realName)) {
                                                Model.isPayVerifyBank = true;
                                                initPayVerifyBank('payVerity');
                                            }
                                            if(!data.bankInfoCN && !$scope.Model.mercShortName && payVerifyBank.bankAcctName && payVerifyBank.bankAcctName.length < 21){
                                                $scope.Model.mercShortName = payVerifyBank.bankAcctName;
                                                //    亮化按钮
                                                greenSubmit();
                                                $scope.isBankCNChanged = true
                                            }
                                        });
                                        //如果是境内的判断
                                        if (Model.isSeleteCNTbs && !((data.bankInfoCN && data.bankInfoCN.verifyBankState === 1) || (data.bankInfoCN && data.bankInfoCN.updateBankState === 1))  && $scope.mainUserID && !$scope.isLegal && (!Model.agreements.petalsTremServiceAgree.isSignedAgree || !Model.agreements.petalsServiceAgree.isSignedAgree)) {
                                            auiDialog.warn("协议提醒", "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请联系主帐号或法务查看、签署相关协议。", function () {
                                                Model.isCheckedBankEN = true;
                                                Model.isSeleteCNTbs = false;
                                                Model.isCheckedBankCN = false;
                                                Model.isSeleteCNTbs = false;
                                            });
                                        }
                                        defer.resolve(true);
                                    }
                                });
                            }

                        });
                    });
                });
                return defer.promise;
            }

            function initPayVerifyBank(payFl) {
                if (payVerifyBank) {
                    Model.bankInfoCN = payVerifyBank;
                    initBankInfoCNData(payFl);
                    if (document.querySelector('#backAutoCN_value')) {
                        document.querySelector('#backAutoCN_value').key = Model.bankInfoCN.bankName;
                        document.querySelector('#backAutoCN_value').value = Model.bankInfoCN.bankName;
                    }
                    if (document.querySelector('#branchAutoCN_value')) {
                        document.querySelector('#branchAutoCN_value').key = Model.bankInfoCN.hAddr;
                        document.querySelector('#branchAutoCN_value').value = Model.bankInfoCN.hAddr;
                    }
                    $scope.isBankCNChanged = true;
                }
            }

            function clickPayVerifyBank() {
                if (!Model.isCheckPayVerifyBank) {
                    Model.isCheckPayVerifyBank = true;
                    initPayVerifyBank('payVerity');
                } else {
                    Model.isCheckPayVerifyBank = false;
                    Model.bankInfoCN = {
                        country: Model.bankInfoCN.country,
                        accountName: Model.bankInfoCN.accountName
                    };
                    Model.bankInfoCN.bank = {key: '', value: '请选择开户银行'};
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    // 改变银行省后，需要将之前的银行信息清除
                    document.querySelector('#backAutoCN_value').value = '';
                    $scope.$broadcast('huaweicomplete-alt:clearInput', 'backAutoCN');
                    document.querySelector('#branchAutoCN_value').value = '';
                    $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoCN');
                    $scope.isBankCNChanged = false;
                }
            }

            //校验银行数据
            function renderBankData(developerInfo) {
                if (developerInfo.isChangeRealName === 1) {
                    Model.isAudting = true;
                }
                initBankInfoCNData();
                initBankInfoENData();
                if (!Model.bankInfoCN.bankName && Model.bankInfoEN.bankName) {
                    Model.isSeleteCNTbs = false;
                } else {
                    Model.isCheckedBankCN = true;
                }
                Model.coraccountNameDisable = false;
                if (Model.userType == 2) {
                    if (Model.bankInfoCN.accountName == developerInfo.realName) {
                        Model.coraccountTipMsg = mainCons.modUserinfoConstant.accountNameEqTip.eqTip;
                        Model.coraccountNameDisable = true;
                    } else {
                        Model.coraccountTipMsg = mainCons.modUserinfoConstant.accountNameEqTip.notEqTip;
                        Model.coraccountNameDisable = false;
                    }
                }
                initIdentityInfo()
                operationInfo()
            }
            function initIdentityInfo() {
                if(Model.isCheckedBankCN ) {
                    if(Model.userInfo.userType === 2) {
                        if((!Model.myUserInfo.corpEntityPicFile || !Model.myUserInfo.corpEntityPicFile1 || !Model.myUserInfo.contactorImg10)
                            && (Model.userInfo.verifyBankState !== 2)
                        ) {
                            if(Model.myUserInfo.isSupplementalAttachments === 0) {
                                Model.identityInfo = (Model.isAudting && Model.developerAttachment.attachment4) || !Model.isAudting;
                            }else {
                                Model.identityInfo = false
                            }
                        }else {
                            Model.identityInfo = false
                        }
                    }else {
                        if((!Model.myUserInfo.perCtfFg || !Model.myUserInfo.perCtfBg) && (Model.userInfo.verifyBankState !== 2)) {
                            if(Model.myUserInfo.isSupplementalAttachments === 0) {
                                Model.identityInfo = (Model.isAudting && Model.developerAttachment.attachment1) || !Model.isAudting;
                            }else {
                                Model.identityInfo = false
                            }
                        }else {
                            Model.identityInfo = false
                        }
                    }
                }else {
                    Model.identityInfo = false
                }
            }

            function operationInfo() {
                if(Model.isCheckedBankCN ) {
                    Model.operationInfoFlag = true
                }else {
                    Model.operationInfoFlag = false
                }
            }

            function initBankInfoCNData(payFl) {
                if (Model.bankInfoCN && (Model.bankInfoCN.bankName || Model.bankInfoCN.bank)) {
                    Model.bankInfoCN.bankAccount = Model.bankInfoCN.bankAccount;
                    Model.bankInfoCN.accountName = Model.bankInfoCN.bankAcctName;
                    //总行 省 市 支行 开户行号
                    Model.bankInfoCN.bank = {
                        key: Model.bankInfoCN.bankName,
                        value: Model.bankInfoCN.bankName
                    };
                    lastSelBank = Model.bankInfoCN.bank.key;
                    Model.bankInfoCN.province = {
                        key: Model.bankInfoCN.hProvince,
                        value: Model.bankInfoCN.hProvince
                    };
                    Model.bankInfoCN.city = {
                        key: Model.bankInfoCN.hCity,
                        value: Model.bankInfoCN.hCity
                    };
                    Model.bankInfoCN.branch = {
                        key: Model.bankInfoCN.hAddr,
                        value: Model.bankInfoCN.hAddr
                    };
                    lastSelBranch = Model.bankInfoCN.branch.key;
                    $scope.initBranchValue = Model.bankInfoCN.branch.key ? Model.bankInfoCN.branch.key : '';
                    //国家 币种 税票类型信息
                    Model.bankInfoCN.country = {key: "CN", value: '中国'};
                    Model.bankInfoCN.branchNumber = Model.bankInfoCN.branchNumber;
                    getBankBranchRegions(Model.bankInfoCN.bank.key, Model.bankInfoCN.province.key, Model.bankInfoCN.city.key, Model.bankInfoCN.branch.key, true);
                }

                if (Model.bankInfoCN && Model.bankInfoCN.bankAttachment) {
                    Model.bankAccountPicCN = Model.bankInfoCN.bankAttachment;
                    //attachment,whDist,$scope,Model
                    modBussService.auiDrawImage(Model.bankInfoCN.bankAttachment, 'bankAccountPicCNWH', $scope, Model);
                }
                if (Model.bankInfoCN && Model.bankInfoCN.acctNameAttachment) {
                    Model.acctNameAttachmentCN = Model.bankInfoCN.acctNameAttachment;
                    //attachment,whDist,$scope,Model
                    modBussService.auiDrawImage(Model.acctNameAttachmentCN, 'acctNameAttachmentENWH', $scope, Model);
                }

                if (!payFl) {
                    oldBankInfoCN = angular.copy(Model.bankInfoCN);
                }
                oldBankInfoCN.bankAccount = Model.bankInfoCN.bankAccount;
                if (Model.bankInfoCN && Model.bankInfoCN.bankAccount) {
                    Model.bankInfoCN.bankAccount = formValidateService.hiddenInfo(Model.bankInfoCN.bankAccount, 0, 4);
                    Model.bankInfoCN.bankAccountFuzzy = angular.copy(Model.bankInfoCN.bankAccount);
                }

            }

            function initBankInfoENData() {
                if (Model.bankInfoEN && (Model.bankInfoEN.bankName || Model.bankInfoEN.bank)) {
                    Model.bankInfoEN.bankAccount = Model.bankInfoEN.bankAccount;
                    Model.bankInfoEN.accountName = Model.bankInfoEN.bankAcctName;
                    //总行 省 市 支行 开户行号
                    Model.bankInfoEN.bank = {key: Model.bankInfoEN.bankName, value: Model.bankInfoEN.bankName};
                    lastSelBankEN = Model.bankInfoEN.bank.key;
                    Model.bankInfoEN.branch = {key: Model.bankInfoEN.hAddr, value: Model.bankInfoEN.hAddr};
                    lastSelBranchEN = Model.bankInfoEN.branch.key;
                    $scope.initBranchValueEN = Model.bankInfoEN.branch.key ? Model.bankInfoEN.branch.key : '';
                    //国家 币种 税票类型信息
                    Model.AllCountrys.forEach(function (countryen) {
                        if (countryen.key == Model.bankInfoEN.country) {
                            Model.bankInfoEN.country = angular.copy(countryen);
                        }
                    })
                    if (Model.bankWhitelistStatus == 0 && Model.bankInfoEN.country.key != 'CN') {
                        Model.countrys4EN = angular.copy([{key: "CN", value: '中国'}, Model.bankInfoEN.country]);
                    } else if (Model.bankWhitelistStatus == 0 && Model.bankInfoEN.country.key == 'CN') {
                        Model.countrys4EN = angular.copy([{key: "CN", value: '中国'}]);
                    }
                    Model.bankInfoEN.branchNumber = Model.bankInfoEN.branchNumber;
                    Model.bankInfoEN.bankAccountCp = Model.bankInfoEN.bankAccount;
                    getBankBranchsEN(Model.bankInfoEN.bank.key, Model.bankInfoEN.branch.key, true);
                }

                if (Model.bankInfoEN && Model.bankInfoEN.bankAttachment) {
                    Model.bankAccountPicEN = Model.bankInfoEN.bankAttachment;
                    //attachment,whDist,$scope,Model
                    modBussService.auiDrawImage(Model.bankAccountPicEN, 'bankAccountPicENWH', $scope, Model);
                }
                if (Model.bankInfoEN && Model.bankInfoEN.acctNameAttachment) {
                    Model.acctNameAttachmentEN = Model.bankInfoEN.acctNameAttachment;
                    modBussService.auiDrawImage(Model.acctNameAttachmentEN, 'acctNameAttachmentENWH', $scope, Model);
                }
                if (Model.bankInfoEN.currency) {
                    Model.bankInfoEN.currencyObj = {key: Model.bankInfoEN.currency, value: Model.bankInfoEN.currency};
                    //对RS特殊处理 塞尔维亚  后面考虑抽出来吧
                    if (Model.bankInfoEN.currency == 'EUR' && Model.bankInfoEN.country && Model.bankInfoEN.country.key == 'RS') {
                        $scope.selectCountryCfg.iban.required = true;
                    }
                }


                oldBankInfoEN = angular.copy(Model.bankInfoEN);
                if (Model.bankInfoEN && Model.bankInfoEN.bankAccount) {
                    Model.bankInfoEN.bankAccountOld = angular.copy(Model.bankInfoEN.bankAccount);
                    Model.bankInfoEN.bankAccount = formValidateService.hiddenInfo(Model.bankInfoEN.bankAccount, 0, 4);
                    Model.bankInfoEN.bankAccountFuzzy = angular.copy(Model.bankInfoEN.bankAccount);
                    Model.bankInfoEN.bankAccountCp = formValidateService.hiddenInfo(Model.bankInfoEN.bankAccountCp, 0, 4);
                }

            }

            function setAccountCurrencys() {
                $scope.Model.accountCurrency.selectCurrencys = [];
                for (var i = 0; i < Model.defaultCountrysList.length; i++) {
                    $scope.Model.accountCurrency.selectCurrencys.push(Model.defaultCountrysList[i]);
                }

            }

            Model.changeAccountCurrency = function () {
                Model.bankInfoEN.currencyObj = {};
                Model.accountCurrency.showDefualErrorMsg = true;
                if (Model.accountCurrency.selectCurrencys.length == 0) {
                    Model.accountCurrency.showAccountErrorMsg = true;
                } else {
                    Model.accountCurrency.showAccountErrorMsg = false;
                }
            };


            Model.bankAccountCnKeyup = function () {
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldBankInfoCN.bankAccount) {
                    if (oldBankInfoCN.bankAccount != Model.bankInfoCN.bankAccount && Model.bankInfoCN.bankAccountFuzzy != Model.bankInfoCN.bankAccount) {
                        if (!formValidateService.testBankAccout(Model.bankInfoCN.bankAccount)) {
                            Model.bankAccountPattern.cn = true;
                            return;
                        }
                    }
                } else {
                    if (!formValidateService.testBankAccout(Model.bankInfoCN.bankAccount)) {
                        Model.bankAccountPattern.cn = true;
                        return;
                    }
                }

                Model.bankAccountPattern.cn = false;
            }
            //修改商户简称
            Model.mercShortNameCnKeyup = function (){
                if($scope.Model.mercShortName){
                    // 如果新值改变 亮化提交按钮 否则灰化
                    if($scope.Model.mercShortName != Model.defalutMercShortName){
                        greenSubmit();
                        $scope.isBankCNChanged = true
                    }else {
                        graySubmit();
                    }
                }
            }
            Model.bankAccountEnKeyup = function () {
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldBankInfoEN.bankAccount) {
                    if (oldBankInfoEN.bankAccount != Model.bankInfoEN.bankAccount && Model.bankInfoEN.bankAccountFuzzy != Model.bankInfoEN.bankAccount) {
                        if (!formValidateService.testBankAccout(Model.bankInfoEN.bankAccount)) {
                            Model.bankAccountPattern.en = true;
                            return;
                        }
                    }
                } else {
                    if (!formValidateService.testBankAccout(Model.bankInfoEN.bankAccount)) {
                        Model.bankAccountPattern.en = true;
                        return;
                    }
                }
                Model.bankAccountPattern.en = false;
            }

            //校验离岸帐号
            Model.validlaBankAccount = function () {
                var pattern = new RegExp($scope.selectCountryCfg.accountNumber.pattern);
                if (oldBankInfoEN.bankAccount) {
                    if (oldBankInfoEN.bankAccount != Model.bankInfoEN.bankAccount && Model.bankInfoEN.bankAccountFuzzy != Model.bankInfoEN.bankAccount) {
                        if (!pattern.test(Model.bankInfoEN.bankAccount)) {
                            $scope.selectCountryCfg.accountNumber.showError = true;
                            return;
                        }
                    }
                } else {
                    if (!pattern.test(Model.bankInfoEN.bankAccount)) {
                        $scope.selectCountryCfg.accountNumber.showError = true;
                        return;
                    }
                }
                $scope.selectCountryCfg.accountNumber.showError = false;
            }


            //选择英文银行收款账户
            function clickCheckboxEN($event, flag) {
                if (flag) return;
                if (!Model.isCheckedBankEN) {
                    Model.isCheckedBankEN = true;
                    Model.isSeleteCNTbs = false;
                } else {
                    Model.isCheckedBankEN = false;
                    Model.isSeleteCNTbs = true;
                    $scope.isBankENChanged = false;
                }
                // 如果未变化，则灰化提交按钮
                isGreeOrGray();
            }

            //选择中文银行收款账户
            function clickCheckboxCN($event, flag) {
                if (flag) return;
                if (!Model.isCheckedBankCN) {
                    //如果是境内的判断
                    if ($scope.mainUserID && !$scope.isLegal && (!Model.agreements.petalsTremServiceAgree.isSignedAgree || !Model.agreements.petalsServiceAgree.isSignedAgree)) {
                        auiDialog.warn("协议提醒", "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请联系主帐号或法务查看、签署相关协议。")
                    } else {
                        Model.isCheckedBankCN = true;
                        Model.isSeleteCNTbs = true;
                        if (Model.isPayVerifyBank) {
                            greenSubmit();
                        }
                        if($scope.Model.mercShortName != $scope.Model.defalutMercShortName){
                            $scope.isBankCNChanged = true;
                        }
                    }
                } else {
                    Model.isCheckedBankCN = false;
                    Model.isSeleteCNTbs = false;
                    if (Model.isPayVerifyBank) {
                        graySubmit();
                    } else {
                        $scope.isBankCNChanged = false;
                    }
                }
                // 如果未变化，则灰化提交按钮
                isGreeOrGray();
                initIdentityInfo()
                operationInfo()
            }

            //初始化国家、币种
            function bankInit() {
                //获取境内银行
                bankSelectService.getBanks(0, function (data) {
                    if (data) {
                        data.forEach(function (bank) {
                            Model.bankCNs.push(bank);
                        });
                    }
                });

            }

            //开户银行失去焦点调用
            function bankFocusOut() {
                //新增初始化时Model.bankInfoCN.bank为空，需要初始化.
                if (!Model.bankInfoCN.bank) {
                    Model.bankInfoCN.bank = {
                        key: '',
                        value: ''
                    }
                }
                // 获取backAuto 的值
                var backAutoVal = document.querySelector('#backAutoCN_value').value;
                if (backAutoVal) {
                    backAutoVal = backAutoVal.trim();
                    var banks = Model.bankCNs;
                    var len = banks.length;
                    //找到输入的中文银行
                    var found = false;
                    for (var i = 0; i < len; i++) {
                        if (banks[i].key === backAutoVal) {
                            found = true;
                            return;
                        }
                    }
                    if (!found && Model.bankCNs) {
                        Model.bankInfoCN.bank.value = '';
                        $scope.bankInfoForm.bankCN.$setDirty();
                    }
                } else {
                    if (Model.bankCNs) {
                        Model.bankInfoCN.bank.value = '';
                        $scope.bankInfoForm.bankCN.$setDirty();
                    }
                }
            }

            //开户银行失去焦点调用
            function bankFocusOutEN() {
                !Model.bankInfoEN.bank && (Model.bankInfoEN.bank = {key: '', value: ''});
                // 获取backAuto 的值
                var backAutoVal = document.querySelector('#backAutoEN_value').value;
                if (backAutoVal) {
                    backAutoVal = backAutoVal.trim();
                    var banks = Model.bankENs;
                    var len = banks.length;
                    //找到输入的英文银行,或者离岸银行找不到
                    var found = isInArray(banks, 'key', backAutoVal);
                    if (!found && Model.bankENs) {
                        Model.bankInfoEN.bank.value = '';
                        $scope.bankInfoForm.bankEN.$setDirty();
                    }
                } else {
                    if (Model.bankENs) {
                        Model.bankInfoEN.bank.value = '';
                        Model.branchsEN = [];
                        document.querySelector('#branchAutoEN_value').value = '';
                        $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoEN');
                        $scope.bankInfoForm.bankEN.$setDirty();
                    }
                }
            }

            //上传法人视频
            Model.uploadVideo = function (files, options) {
                if (Model.isAudting) return;
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    Model.bankInfoCN.legalManVideoUrl = fileUrl;
                    changeBankInfoCN();
                })
            }

            //选择某一开户银行触发调用
            function backSelected(obj) {
                //新增初始化时Model.bankInfo.bank为空，需要初始化.
                !Model.bankInfoCN.bank && (Model.bankInfoCN.bank = {key: '', value: ''});

                if (obj) {
                    //带title:选中的
                    if (obj.title) {
                        Model.bankInfoCN.bank.key = obj.title;
                        Model.bankInfoCN.bank.value = obj.title;
                        if (obj.title != lastSelBank) {
                            lastSelBank = obj.title;
                            changeBank(Model.bankInfoCN.bank.value);
                        }
                    } else if (obj.originalObject.key) {
                        Model.bankInfoCN.bank.key = obj.originalObject.key;
                        Model.bankInfoCN.bank.value = obj.originalObject.key;
                        if (obj.originalObject.key != lastSelBank) {
                            lastSelBank = obj.originalObject.key;
                            changeBank(Model.bankInfoCN.bank.value);
                        }
                    }
                } else {
                    Model.bankInfoCN.bank.key = '';
                    Model.bankInfoCN.bank.value = '';
                }

            }

            //选择某一开户银行触发调用
            function backSelectedEN(obj) {
                var isOffSite = Model.bankInfoEN.country.key != 'CN';
                ///需要区分初次加载,离岸银行需要等待OpenUp.getBankList加载完成
                if (isOffSite && initController) {
                    return;
                }
                //新增初始化时Model.bankInfo.bank为空，需要初始化.
                !Model.bankInfoEN.bank && (Model.bankInfoEN.bank = {key: '', value: ''});
                if (obj) {
                    //带title:选择的
                    if (obj.title) {
                        Model.bankInfoEN.bank.key = obj.title;
                        Model.bankInfoEN.bank.value = obj.title;
                        //只要是选择的就不显示
                        Model.isShowUpdateBankEN = false
                        //离岸银行特殊处理,bankNumber不合法给修改
                        Model.bankInfoEN.bankNumber = modBussService.getFieldValueForCfg('bankNumber', obj.originalObject && obj.originalObject.bankNumber, $scope);
                    } else if (obj.originalObject.key) {
                        Model.bankInfoEN.bank.key = obj.originalObject.key;
                        Model.bankInfoEN.bank.value = obj.originalObject.key;
                        isOffSite && obj.originalObject.bankNumber && (Model.bankInfoEN.bankNumber = obj.originalObject.bankNumber);
                        //离岸银行显示提示
                        isOffSite && (Model.isShowUpdateBankEN = true);
                    }
                    //抽取公共部分
                    if (Model.bankInfoEN.bank.value && Model.bankInfoEN.bank.value != lastSelBankEN) {
                        lastSelBankEN = Model.bankInfoEN.bank.value;
                        changeBankEN(Model.bankInfoEN.bank.value);
                    }
                } else {
                    Model.bankInfoEN.bank.key = '';
                    Model.bankInfoEN.bank.value = '';
                }
            }

            //改变英文国家
            function changeCountryEN() {
                //如果是离岸银行则查询银行规则
                getOffSiteBankRules(Model.bankInfoEN.country && Model.bankInfoEN.country.key, function (isOffSite) {
                    // 如果新值跟原值不一样，则亮化提交按钮
                    if (oldBankInfoEN.country && oldBankInfoEN.country.value != Model.bankInfoEN.country.value || !oldBankInfoEN.country && Model.bankInfoEN.country.value) {
                        Model.bankInfoEN.bank = {key: '', value: ''};
                        Model.bankInfoEN.branch = {key: '', value: ''};
                        Model.bankInfoEN.branchNumber = '';
                        Model.branchsEN = [];
                        Model.accountCurrency.allCurrencys = [];

                        Model.bankInfoEN.currencyObj = {};
                        Model.bankInfoEN.currency = '';
                        Model.bankInfoEN.accountCurrencys = '';
                        Model.accountCurrency.selectCurrencys = [];
                        Model.acctNameAttachmentEN = '';
                        //(Model.bankInfoEN.country.key, Model.bankInfoEN.accountCurrencys);
                    }
                    // 改变银行省后，需要将之前的银行信息清除
                    setTimeout(function () {
                        document.querySelector('#backAutoEN_value').value = '';
                        $scope.$broadcast('huaweicomplete-alt:clearInput', 'backAutoEN');
                        document.querySelector('#branchAutoEN_value').value = '';
                        $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoEN');
                        $scope.bankInfoForm.bankEN.$setPristine();
                    }, 10);
                    changeBankInfoEN();
                    fetchBankList();
                });
            }

            //改变银行
            function changeBank(bank) {
                getBankBranchRegions(bank);
                // 如果新值跟原值不一样，则亮化提交按钮
                if (Model.bankInfoCN.bank && (oldBankInfoCN.bank && oldBankInfoCN.bank.value != Model.bankInfoCN.bank.value || !oldBankInfoCN.bank && Model.bankInfoCN.bank.value)) {
                    Model.bankInfoCN.province = {key: '', value: '省份/直辖市'};
                    Model.bankInfoCN.city = {key: '', value: '市/区'};
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    Model.bankInfoCN.branchNumber = '';
                    Model.bankCities = [];
                    Model.branchs = [];
                    // 改变银行省后，需要将之前的银行信息清除
                    document.querySelector('#branchAutoCN_value').value = '';
                    $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoCN');
                    $scope.bankInfoForm.bankCNCity.$setPristine();
                    $scope.bankInfoForm.bankCNProvince.$setPristine();
                    $scope.bankInfoForm.bankCNBranch.$setPristine();
                }
                changeBankInfoCN();
            }

            //改变银行
            function changeBankEN(bank) {
                var isOffSite = Model.bankInfoEN.country.key != 'CN';
                getBankBranchsEN(bank);
                var change = changeBankInfoEN();
                // 如果新值跟原值不一样，则亮化提交按钮
                if (change) {
                    Model.bankInfoEN.branch = {key: '', value: ''};
                    document.querySelector('#branchAutoEN_value').value = '';
                    $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoEN');
                    Model.bankInfoEN.branchNumber = '';
                    Model.bankInfoEN.branchName = '';
                    !isOffSite && (Model.bankInfoEN.bankNumber = '');
                    Model.bankInfoEN.swiftCode = '';
                    Model.branchsEN = [];
                    $scope.bankInfoForm.bankENBranch.$setPristine();
                }

            }

            //改变银行里面的省
            function changeBankProvince(province) {
                //解决修改银行名称，调用查询支行报错的问题
                if (!Model.bankInfoCN.bank.key) {
                    return;
                }
                getCities(Model.bankInfoCN.bank.key, province);
                // 如果新值跟原值不一样，则亮化提交按钮
                if (Model.bankInfoCN.province && (oldBankInfoCN.province && oldBankInfoCN.province.value != Model.bankInfoCN.province.value || !oldBankInfoCN.province && Model.bankInfoCN.province.value)) {
                    Model.bankInfoCN.city = {key: '', value: '市/区'};
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    Model.bankInfoCN.branchNumber = '';
                }
                changeBankInfoCN();
            }

            //改变银行的城市
            function changeBankCity(city) {
                getBankBranchs(Model.bankInfoCN.bank.key, Model.bankInfoCN.province.value, city);
                // 如果新值跟原值不一样，则亮化提交按钮
                if (Model.bankInfoCN.city && (oldBankInfoCN.city && oldBankInfoCN.city.value != Model.bankInfoCN.city.value || !oldBankInfoCN.city && Model.bankInfoCN.city.value)) {
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    Model.bankInfoCN.branchNumber = '';
                    // 改变银行省后，需要将之前的银行信息清除
                    document.querySelector('#branchAutoCN_value').value = '';
                    $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoCN');
                }
                changeBankInfoCN();
            }

            //keyup事件校验
            function accountNameKeyup() {
                changeBankInfoCN();
                modBussService.validBankParamForBuss(oldUserInfo, Model);
            }

            function changeCurrencyEn(curr) {
                modBussService.changeCurrencyEn(Model, curr);
                //对RS特殊处理 塞尔维亚  后面考虑抽出来吧
                if (Model.bankInfoEN.country && Model.bankInfoEN.country.key == 'RS') {
                    if (curr == 'EUR') {
                        Model.isHandleIbanForCountry = angular.copy($scope.selectCountryCfg.iban.required);
                        $scope.selectCountryCfg.iban.required = true;
                    } else {
                        if ($scope.selectCountryCfg.iban.required) {
                            $scope.selectCountryCfg.iban.required = angular.copy(Model.isHandleIbanForCountry) || false;
                        }
                    }
                }
                changeBankInfoEN();
            }

            function getBankBranchRegions(bank, province, city, branch, fl) {
                bankSelectService.getBankBranchRegions(bank, function (data) {
                    Model.bankProvinces = data;
                    if (province) {
                        getCities(bank, province, city, branch, fl);
                    }
                });
            }

            function getBankBranchs(bank, province, city, branch, fl) {
                bankSelectService.getBankBranchs(bank, province, city, function (data) {
                    bankSelectService.handleAfterGetBankBranchs(Model, data, branch, fl);
                });
            }

            function getCities(bank, province, city, branch, fl) {
                // 调用opendeveloper接口从idata中获取省下面的市的信息。
                bankSelectService.getBankBranchRegionsCity(bank, province, function (cityData) {
                    Model.bankCities = cityData;
                    if (city) {
                        getBankBranchs(bank, province, city, branch, fl);
                    }
                });
            }


            function getBankBranchsEN(bank, branch, loaded) {
                bankSelectService.getBankBranchsEN(bank, null, null, function (data) {
                    //离岸需要转换
                    var isOffSite = Model.bankInfoEN.country.key != 'CN';
                    isOffSite ? Model.branchsEN = convertBranchs(Model.branchsEN, data) : Model.branchsEN = data;
                    var flag = isInArray(Model.branchsEN, 'value', branch);
                    var branchTemp = getInArray(Model.branchsEN, 'value', branch);
                    if (!flag && loaded) {
                        Model.isShowNomatchBranch = true;
                    }
                    // 如果指定了支行信息，则获取到对应的支行号，从getBankBranchs中会自动带出来。
                    if (branchTemp && !isOffSite) {
                        // 获取
                        Model.bankInfoEN.branchNumber = branchTemp.branchNumber;
                        if (branchTemp.swiftCode) {
                            Model.bankInfoEN.swiftCode = branchTemp.swiftCode;
                        } else {
                            $scope.bankInfoForm.swiftCodeEN.$setDirty();
                        }

                    }
                    if(branchTemp){
                        Model.isKcDisabled = (branchTemp.kc == Model.bankInfoEN.kc) || (Model.bankInfoEN.verifyBankState == 2 && !!Model.bankInfoEN.kc );
                    }

                    //下面新增离岸银行逻辑
                    var cfg = $scope.selectCountryCfg;
                    // 如果指定了支行信息，则获取到对应的支行号，从getBankBranchs中会自动带出来。
                    if (branchTemp && isOffSite) {
                        // 如果指定了支行信息，则获取到对应的支行号，从getBankBranchs中会自动带出来。字段信息优先从bankInfo中取
                        branchTemp.branchNumber && !Model.bankInfoEN.branchNumber && (Model.bankInfoEN.branchNumber = branchTemp.branchNumber);
                        branchTemp.swiftCode && !Model.bankInfoEN.swiftCode && (Model.bankInfoEN.swiftCode = branchTemp.swiftCode);
                        cfg.city && cfg.city.showFlag && !Model.bankInfoEN.hCity && (Model.bankInfoEN.hCity = branchTemp.hCity);
                        cfg.branchAddress && !Model.bankInfoEN.branchAddress && cfg.branchAddress.showFlag && (Model.bankInfoEN.branchAddress = branchTemp.branchAddress);
                    }
                }, ((Model.bankInfoEN && Model.bankInfoEN.country && Model.bankInfoEN.country.key != 'CN') ? Model.bankInfoEN.country.key : 'CN'));
            }


            //上传银行的图片
            function uploadBankAccountPic(files, options) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    var changed = fileUrl && fileUrl != Model.bankAccountPicCN;
                    isGreeOrGray() && changed && greenSubmit();
                    if (changed) {
                        urlTemp = fileUrl;
                        Model.bankAccountPicCN = fileUrl;
                        if (Model.bankAccountPicCN.indexOf('.pdf') == -1) {
                            modBussService.auiDrawImage(fileUrl, 'bankAccountPicWH', $scope, Model);
                        } else {
                            Model.bankAccountPicWH = {width: "180px", height: "120px", left: "0px", top: "0px"};
                        }
                    }
                });
            }

            //上传资质图片
            function uploadAcctNameAttachment(files, options, type) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    var changed = fileUrl && fileUrl != Model[type];
                    if (changed) {
                        isGreeOrGray() && changed && greenSubmit();
                        if (urlTempAttachmentCN && type.indexOf('CN') > 0) {
                            urlTempAttachmentCN = fileUrl;
                        } else if (urlTempAttachmentEN && type.indexOf('CN') == -1) {
                            urlTempAttachmentEN = fileUrl;
                        }

                        Model[type] = fileUrl;
                        if (Model[type].indexOf('.pdf') == -1) {
                            modBussService.auiDrawImage(fileUrl, 'acctNameAttachmentENWH', $scope, Model);
                        } else {
                            Model.acctNameAttachmentENWH = {width: "180px", height: "120px", left: "0px", top: "0px"};
                        }
                        //检查是否改变
                        if (type.indexOf('CN') > 0) {
                            changeBankInfoCN();
                        } else {
                            changeBankInfoEN()
                        }

                    }
                });
            }

            //上传银行的图片
            function uploadBankAccountPicEN(files, options) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    var changed = fileUrl && fileUrl != Model.bankAccountPicEN;
                    if (changed) {
                        isGreeOrGray() && changed && greenSubmit();
                        urlTempEN = fileUrl;
                        Model.bankAccountPicEN = fileUrl;
                        if (Model.bankAccountPicEN.indexOf('.pdf') == -1) {
                            modBussService.auiDrawImage(fileUrl, 'bankAccountPicENWH', $scope, Model);
                        } else {
                            Model.bankAccountPicENWH = {width: "180px", height: "120px", left: "0px", top: "0px"};
                        }
                    }
                });
            }

            //税务初始化
            function taxInit() {
                //初始化税票类型
                Model.taxReceiptTypes = modBussService.getTaxReceiptTypes(Model);
                //初始化加拿大税务
                modBussService.getMerchantTaxInfo(Model);
            }


            //设置税务信息，从userTaxInfo中获取
            function renderTaxData(developerInfo, userTaxInfo) {
                modBussService.setTaxData(developerInfo, userTaxInfo, Model, taxType);
                if (!Model.isAudting) {
                    regionService.getProvinceByName(Model.incorDeveloper.provinceName, function (res) {
                        if (!res) {
                            auiDialog.warn('省份不准确', '您注册的省份不准确，请重新提交。', function () {
                                $rootScope.toSettingUserInfo();
                            });
                        }
                        // 供税务下拉的省市（包括城市）列表（现在要求与实名认证的省市一致）
                        Model.taxInfoForSelect.province = [{key: Model.incorDeveloper.provinceName, value: res}];
                    });

                    regionService.getCityByName(Model.incorDeveloper.cityName, function (res) {
                        if (!res) {
                            auiDialog.warn('城市不准确', '您注册的城市不准确，请重新提交。 ', function () {
                                $rootScope.toSettingUserInfo();
                            });
                            return;
                        }
                        Model.taxInfoForSelect.city = [{key: Model.incorDeveloper.cityName, value: res}];
                    });
                }
                oldTaxInfo = angular.copy(Model.taxInfo);
            }

            //改变税务的省
            function changeTaxProvince(province) {
                regionService.setCity(province, function (data) {
                    Model.taxCities = data;
                    if (Model.taxInfo.province && (oldTaxInfo.province && oldTaxInfo.province.value != Model.taxInfo.province.value || !oldTaxInfo.province && Model.taxInfo.province.value)) {
                        if (Model.taxInfoForSelect.city && Model.taxInfoForSelect.city.length == 1) Model.taxInfo.city = Model.taxInfoForSelect.city[0];
                    }
                    changeTax();
                });

            }

            //改变税务类型
            function changeTaxReceiptType() {
                Model.isInTaxReceiptTypes = false;
                changeTax();
            }

            //改变税务注册地址
            function registerAddressKeyup() {
                Model.isInTaxReceiptTypes = false;
                changeTax();
            }
            //选择是否在加拿大开展业务


            //初始化联系人
            function contactorInit() {
                //初始化联系方式
                OpenUp.getContactMetaList({req: {}}).then(
                    function (data) {
                        if (data) {
                            Model.merchantContacts = [];
                            Model.contactInfoList = data.contactList;
                            tenantsService.setPageContactInfo(Model, data.contactList);
                        }
                    }
                );
            }

            //增加联系人页面
            function openAddContactorPage() {
                if (Model.isAudting) {
                    return;
                }
                openAddContactor.openPage({
                    userID: Model.userID,
                    close: function () {
                        contactorInit();
                    }
                });
            }

            function validTaxType() {
                var isInTaxReceiptTypes = false;
                Model.taxReceiptTypes.forEach(function (type) {
                    if (type.key == Model.taxInfo.taxReceiptType.key) {
                        isInTaxReceiptTypes = true;
                    }
                });
                return isInTaxReceiptTypes;
            }

            //判断是灰化还是绿化
            function isGreeOrGray() {
                var noChanged = !$scope.isBankCNChanged && !$scope.isBankENChanged && !$scope.isContractorChanged && !$scope.isTaxChanged && !Model.isControllerChanged;
                noChanged ? graySubmit() : greenSubmit();
                return noChanged;
            }

            // 提交按钮灰化
            function graySubmit() {
                Model.submbIsGray = true;
                $scope.doSubmit = function () {
                };
            }

            // 提交按钮亮化
            function greenSubmit() {
                Model.submbIsGray = false;
                $scope.doSubmit = doSummit;
            }

            //取消
            function cancel() {
                if ($stateParams.settlement && $stateParams.settlement == 'AccountSettlement') {
                    $rootScope.isGet = true;
                    $state.go('MyAccount.newEarnings.settlement');
                } else {
                    $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                }
            }


            //提交
            function doSummit(isValid) {
                if(!isValid) {
                    for (var key in $scope.bankInfoForm) {
                        if (Object.prototype.hasOwnProperty.call($scope.bankInfoForm, key) === true && key.indexOf('$') < 0) {
                            $scope.bankInfoForm[key].$setDirty();
                        }
                    }
                }
                if(Model.taxItemCount == undefined && Model.otherTaxsIncluded == 2 && Model.isCheckedBankEN){
                    if ($scope.bankInfoForm['taxItem']) $scope.bankInfoForm['taxItem'].$dirty = true;
                    return
                }
                if(Model.otherTaxsIncluded == 0 && Model.isCheckedBankEN){
                    if ($scope.bankInfoForm['otherTaxsIncluded']) $scope.bankInfoForm['otherTaxsIncluded'].$dirty = true;
                    return
                }

                if(Model.operationInfoFlag) {
                    Model.checkSceneFlag = (Model.chooseSceneList.length === 0)
                    if(Model.checkSceneFlag) {
                        return
                    }
                }

                var defer = $q.defer();

                Model.defaultCountrys = [];
                Model.defaultCountrysList.forEach(function (val) {
                    Model.defaultCountrys.push(val.value)
                });
                if (!Model.isCheckedBankCN  && !Model.agreements.petalsTremServiceAgree.isSignedAgree && (!$scope.mainUserID || $scope.isLegal)) {
                    Model.petalsTremServicIsSelected = false;
                }
                //判断开发者有没有勾选花瓣协议和隐私协议，没签署要做限制
                    if (Model.isCheckedBankCN && !Model.petalsTremServicIsSelected && !Model.agreements.petalsTremServiceAgree.isSignedAgree && Model.agreements.petalsServiceAgree.isSignedAgree) {
                        Model.showTremAgreeWarn = true;
                        Model.showServiceAgreeWarn = false;
                        return;
                    } else if (Model.isCheckedBankCN && !Model.petalsTremServicIsSelected && !Model.agreements.petalsServiceAgree.isSignedAgree && Model.agreements.petalsTremServiceAgree.isSignedAgree) {
                        Model.showServiceAgreeWarn = true;
                        Model.showTremAgreeWarn = false;
                        return;
                    } else if (Model.isCheckedBankCN && !Model.petalsTremServicIsSelected && !Model.agreements.petalsServiceAgree.isSignedAgree && !Model.agreements.petalsTremServiceAgree.isSignedAgree) {
                        Model.showServiceAgreeWarn = true;
                        Model.showTremAgreeWarn = true;
                        return;
                    } else if (Model.isCheckedBankCN && Model.petalsTremServicIsSelected) {
                        Model.showServiceAgreeWarn = false;
                        Model.showTremAgreeWarn = false;
                    }
                if ($scope.bankInfoForm.ctfEffectiveDate) $scope.bankInfoForm.ctfEffectiveDate.$dirty = true;
                if ($scope.bankInfoForm.ctfFrontPicFile) $scope.bankInfoForm.ctfFrontPicFile.$dirty = true;
                if ($scope.bankInfoForm['controllerName0']) $scope.bankInfoForm['controllerName0'].$dirty = true;
                if ($scope.bankInfoForm['controllerName1']) $scope.bankInfoForm['controllerName1'].$dirty = true;
                if ($scope.bankInfoForm['controllerName2']) $scope.bankInfoForm['controllerName2'].$dirty = true;
                if ($scope.bankInfoForm['controllerName3']) $scope.bankInfoForm['controllerName3'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress0']) $scope.bankInfoForm['controllerAddress0'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress1']) $scope.bankInfoForm['controllerAddress1'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress2']) $scope.bankInfoForm['controllerAddress2'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress3']) $scope.bankInfoForm['controllerAddress3'].$dirty = true;
                if ($scope.bankInfoForm.ctfBackPicFile) $scope.bankInfoForm.ctfBackPicFile.$dirty = true;
                if ($scope.bankInfoForm['ctfCode0']) $scope.bankInfoForm['ctfCode0'].$dirty = true;
                if ($scope.bankInfoForm['ctfCode1']) $scope.bankInfoForm['ctfCode1'].$dirty = true;
                if ($scope.bankInfoForm['ctfCode2']) $scope.bankInfoForm['ctfCode2'].$dirty = true;
                if ($scope.bankInfoForm['ctfCode3']) $scope.bankInfoForm['ctfCode3'].$dirty = true;
                if ($scope.bankInfoForm['otherTaxsIncluded'] && Model.isCheckedBankEN) $scope.bankInfoForm['otherTaxsIncluded'].$dirty = true;
                if ($scope.bankInfoForm['taxItem'] && Model.isCheckedBankEN) $scope.bankInfoForm['taxItem'].$dirty = true;
                Model.isNewController = false;

                $scope.bankInfoForm.taxNum && $scope.bankInfoForm.taxNum.$setDirty();
                Model.isInTaxReceiptTypes = false;
                var isOffSite = Model.bankInfoEN.country && Model.bankInfoEN.country.key != 'CN';
                //离岸,加上校验后台的逻辑
                var offSitePassed = tenantsService.checkByServerCfg(Model.bankInfoEN, $scope.selectCountryCfg);
                if ($scope.isAgreementChanged || Model.isControllerChanged || $scope.isContractorChanged || $scope.isTaxChanged || $scope.isBankCNChanged || $scope.isBankENChanged || Model.isReVer || isOffSite && !offSitePassed || Model.identityInfoFlag || Model.operationHasChange) {
                    if (!isValid || (Model.isCheckedBankEN && Model.bankInfoEN.bankAccountCp && Model.bankInfoEN.bankAccountCp != Model.bankInfoEN.bankAccount) || isOffSite && !offSitePassed) {
                        if (Model.isCheckedBankEN && Model.bankInfoEN.bankAccountCp && Model.bankInfoEN.bankAccountCp != Model.bankInfoEN.bankAccount) {
                            formValidateService.validateForm(null, "bankAccountENCp");
                        } else {
                            formValidateService.validateForm($scope.bankInfoForm);
                        }

                        if (Model.isCheckedBankEN && !isOffSite) {
                            if (!modBussService.validCurrency(Model)) {
                                angular.element("[name='bankAccountENCp']").focus();
                                defer.reject();
                            }
                            if (($scope.bankInfoForm.backCountryEN.$dirty && $scope.bankInfoForm.backCountryEN.$invalid) ||
                                ($scope.bankInfoForm.bankEN.$dirty && $scope.bankInfoForm.bankEN.$invalid) ||
                                ($scope.bankInfoForm.bankENBranch.$dirty && $scope.bankInfoForm.bankENBranch.$invalid) ||
                                ($scope.bankInfoForm.accountNameEN.$dirty && $scope.bankInfoForm.accountNameEN.$invalid) ||
                                ($scope.bankInfoForm.bankAccountEN.$dirty && $scope.bankInfoForm.bankAccountEN.$invalid) ||
                                ($scope.bankInfoForm.bankAccountENCp.$dirty && $scope.bankInfoForm.bankAccountENCp.$invalid) ||
                                ($scope.bankInfoForm.bankAccountENCp.$dirty && $scope.bankInfoForm.bankAccountENCp.$valid
                                    && Model.bankInfoEN.bankAccountCp != Model.bankInfoEN.bankAccount) ||
                                ($scope.bankInfoForm.acctNameAttachmentEN.$dirty && $scope.bankInfoForm.acctNameAttachmentEN.$invalid)) {
                                Model.isSeleteCNTbs = false;
                            }
                        }

                        if (Model.isCheckedBankCN) {
                            if (($scope.bankInfoForm.bankCN.$dirty && $scope.bankInfoForm.bankCN.$invalid) ||
                                ($scope.bankInfoForm.accountNameCN.$dirty && $scope.bankInfoForm.accountNameCN.$invalid && !Model.valid.accountNameCNValid.isShowValid) ||
                                !Model.valid.accountNameCNValid.isValidSuc ||
                                ($scope.bankInfoForm.bankCNBranch.$dirty && $scope.bankInfoForm.bankCNBranch.$invalid) ||
                                ($scope.bankInfoForm.bankAccountCN.$dirty && $scope.bankInfoForm.bankAccountCN.$invalid) ||
                                ($scope.bankInfoForm.acctNameAttachmentCN.$dirty && $scope.bankInfoForm.acctNameAttachmentCN.$invalid)) {
                                Model.isSeleteCNTbs = true;
                            }
                        }
                        defer.reject();
                    } else if (!modBussService.validBankParamForBuss(oldUserInfo, Model)) {
                        Model.isSeleteCNTbs = true;
                        $timeout(function () {
                            angular.element("[name='accountNameCN']").focus();
                            defer.reject();
                        }, 20);
                    } else if (!validTaxType()) {
                        Model.isInTaxReceiptTypes = true;
                        angular.element("[name='taxReceiptType']").focus();
                        defer.reject();
                    } else if (Model.isReVer && Model.bankInfoEN && Model.bankInfoEN.country && Model.bankInfoEN.country.key != 'CN' && Model.bankWhitelistStatus == 0) {
                        Model.isSeleteCNTbs = false;
                        $timeout(function () {
                            var backCountryENDiv = angular.element("[name='backCountryEN']");
                            backCountryENDiv && backCountryENDiv.focus();
                            defer.reject();
                        }, 20);
                    } else if (Model.defaultCountrys.indexOf(Model.bankInfoEN.currency) == -1 && Model.bankInfoEN.currencyObj) {//如果存量用户的结算币种不属于六种选择币种范围内，并且没有做修改
                        angular.element("[name='accountCurrency']").focus();
                        defer.reject();
                        Model.accountErrorMsg = true;
                        return;
                    } else if (Model.isCheckedBankEN && Model.bankInfoEN && !Model.bankInfoEN.currencyObj) {
                        angular.element("[name='accountCurrency']").focus();
                        defer.reject();
                        Model.accountCurrency.showDefualErrorMsg = true;
                        return;
                    } else if(!$scope.Model.mercShortName){
                        //没有填写商户简称
                        $timeout(function () {
                            angular.element("[name='mercShortName']").focus();
                            defer.reject();
                        }, 20);
                    } else if(Model.bankAccountPattern.cn){
                        //没有填写商户简称
                        $timeout(function () {
                            angular.element("[name='bankAccountCN']").focus();
                            defer.reject();
                        }, 20);
                    }else {
                        //必须设置一个银行账户信息
                        if (!Model.isCheckedBankCN && !Model.isCheckedBankEN) {
                            defer.reject();
                            return defer.promise;
                        }
                        var hasNoChanged = false
                        if(Model.userInfo.verifyBankState === 3 && !Model.identityInfoFlag  && !Model.operationHasChange) {
                            if((Model.isCheckedBankCN && Model.isCheckedBankEN && !$scope.isBankCNChanged && !$scope.isBankENChanged)){
                                hasNoChanged = true
                            }else if(!Model.isCheckedBankCN && Model.isCheckedBankEN && !$scope.isBankENChanged) {
                                hasNoChanged = true
                            }else if(Model.isCheckedBankCN && !Model.isCheckedBankEN && !$scope.isBankCNChanged) {
                                hasNoChanged = true
                            }
                            if(hasNoChanged) {
                                auiDialog.warn('提示', '您的商户银行信息未修改，请修改后重新提交。', function () {
                                    defer.reject()
                                });
                                return
                            }
                        }
                        Model.checkHKAccountNumberEN = bankSelectService.isChangeBank4OffSite(oldBankInfoEN,Model.bankInfoEN,$scope.selectCountryCfg);
                        modBussService.checkHKAccountNumber(Model).then(function () {
                            //存量境外银行提交时需要确认账户可接受币种不能为空
                            //校验都过的情况下弹出银行卡二次确认
                            //partvner1.0.6新增离岸银行
                            bankSelectService.showConfirmDlg({
                                bankCN: Model.bankInfoCN,
                                bankEN: Model.bankInfoEN,
                                oldBankCN: oldBankInfoCN,
                                oldBankEN: oldBankInfoEN,
                                bankSelectedCN: Model.isCheckedBankCN,
                                bankSelectedEN: Model.isCheckedBankEN,
                                isReVer: Model.isReVer,
                                selectCountryCfg: $scope.selectCountryCfg,
                                isOffSite: Model.bankInfoEN.country.key != 'CN',
                                mercShortName: Model.mercShortName,
                                isChangemercShortName: $scope.isBankCNChanged
                            }).then(function () {
                                var jsonStr = modBussService.beforeSubmitBankInfo(Model, $scope, oldBankInfoCN, oldBankInfoEN);
                                // 根据bankType判断是否是境内提交
                                if(jsonStr.developerMerchantInfo && jsonStr.developerMerchantInfo.developerBanks){
                                    jsonStr.developerMerchantInfo.developerBanks.forEach(function (item){
                                        if(item.bankType == 0){
                                            item['mercShortName'] = $scope.Model.mercShortName
                                        }
                                    })
                                }
                                modBussService.signSingleAgreement(Model, 'merchantServiceAgree', Model.merchantServiceIsSelected).then(function () {
                                    modBussService.signSingleAgreement(Model, 'petalsTremServiceAgree', Model.petalsTremServicIsSelected).then(function () {
                                        modBussService.signSingleAgreement(Model, 'petalsServiceAgree', Model.petalsTremServicIsSelected).then(function () {
                                            if (!angular.equals({}, jsonStr)) {
                                               submitBankInfo(jsonStr).then(function () {
                                                    defer.resolve();
                                                }).catch(function () {
                                                    defer.reject();
                                                });
                                            } else {
                                                auiDialog.success('提交成功。', function () {
                                                    defer.reject();
                                                    cancel();
                                                });
                                            }
                                        });
                                    });
                                }).catch(function (data) {
                                    defer.reject(data);
                                })
                            }, function () {
                                defer.reject();
                            });
                        }).catch(function () {
                            defer.reject();
                            return defer.promise;
                        });

                    }
                } else {
                    defer.reject();
                }
                return defer.promise;
            }


            //提交银行信息
            function submitBankInfo(jsonStr) {
                var defer = $q.defer();
                var succContent = '您还可以通过' + '<a class="text-link" target="_blank" href="' + systemParaConf.appPromotion.url + '">开发者联盟APP</a>随时查询账户收益。'
                modUserInfoService.updateBankInfo(jsonStr, function (data) {
                    if (data.userID) {
                        auiDialog.success('提交成功。', succContent, function () {
                            if ($stateParams.settlement && $stateParams.settlement == 'AccountSettlement') {
                                $rootScope.isGet = true;
                                $state.go('MyAccount.newEarnings.settlement');
                            } else {
                                cancel();
                                $scope.$emit("stateChangedEvent", true);
                            }
                        });
                    } else if (data.NSP_STATUS && data.NSP_STATUS === 70005010 && data.error) {
                        var error = data.error;
                        var re = /\[[^\]]*\]/g;
                        var branchNumber = re.exec(error);
                        var branchName = re.exec(error);
                        var selBranchName = re.exec(error);
                        var msg = "开户行号为" + branchNumber + "对应的支行名称为" + branchName + "，与输入的" + selBranchName + "不匹配，请重新输入或选择。";
                        auiDialog.fail(msg);
                    } else {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS, data.serviceName));
                    }
                    defer.reject();
                });
                return defer.promise;
            }

            // autocomplete 回调方法
            function branchSelected(obj) {
                var isOffSite = Model.bankInfoEN.country.key != 'CN';
                //需要区分初次加载,离岸银行需要等待OpenUp.getBankList加载完成
                if (isOffSite && initController) {
                    return;
                }
                if (obj) {
                    Model.bankInfoCN.branch.key = obj.originalObject.key;
                    Model.bankInfoCN.branch.value = obj.originalObject.value;
                    // 现在不用再调用openother获取支行号。
                    Model.bankInfoCN.branchNumber = obj.originalObject.branchNumber;

                    if (obj.title != lastSelBranch) {
                        lastSelBranch = obj.title;
                    }
                } else {
                    Model.bankInfoCN.branch.key = '';
                    Model.bankInfoCN.branch.value = '';
                }
                changeBankInfoCN();

            }

            // autocomplete 回调方法
            function branchSelectedEN(obj) {
                var isOffSite = Model.bankInfoEN.country.key != 'CN';
                if (obj) {
                    Model.bankInfoEN.branch.key = obj.originalObject.key;
                    Model.bankInfoEN.branch.value = obj.originalObject.value;
                    //如果不是离岸银行
                    if (!isOffSite) {
                        Model.bankInfoEN.branchNumber = obj.originalObject.branchNumber;
                        Model.bankInfoEN.swiftCode = obj.originalObject.swiftCode;
                        if (obj.originalObject.key != lastSelBranchEN) {
                            lastSelBranchEN = obj.originalObject.key;
                        }
                    }
                    //离岸特殊处理
                    else {
                        // 获取开户行号
                        var cfg = $scope.selectCountryCfg;
                        var branchNumberRs = modBussService.getFieldValueForCfg('branchNumber', obj.originalObject.branchNumber, $scope);
                        Model.bankInfoEN.branchNumber = branchNumberRs;
                        Model.bankInfoEN.swiftCode = '';
                        Model.branchsEN && Model.branchsEN.forEach(function (item) {
                            if (item.key == Model.bankInfoEN.branch.key) {
                                var swiftCodeRs = modBussService.getFieldValueForCfg('swiftCode', item.swiftCode, $scope);
                                Model.bankInfoEN.swiftCode = swiftCodeRs;
                                var kcRs = modBussService.getFieldValueForCfg('kc', item.kc, $scope);
                                Model.bankInfoEN.kc = kcRs;
                                var bankNumberRs = modBussService.getFieldValueForCfg('bankNumber', item.bankNumber, $scope);
                                bankNumberRs && (Model.bankInfoEN.bankNumber = bankNumberRs);
                                Model.isKcDisabled = !!item.kc;
                            }
                        });
                        cfg.city && cfg.city.showFlag && (Model.bankInfoEN.hCity = obj.originalObject.hCity);
                        cfg.branchAddress && cfg.branchAddress.showFlag && (Model.bankInfoEN.branchAddress = obj.originalObject.branchAddress);
                    }
                } else {
                    Model.bankInfoEN.branch.key = '';
                    Model.bankInfoEN.branch.value = '';
                    Model.bankInfoEN.branchNumber = '';
                    Model.bankInfoEN.swiftCode = '';
                }
                changeBankInfoEN();
            }

            // 失去焦点事件
            function bankBranchFocusOut() {
                // 获取branchAuto 的值
                var branchAutoVal = document.querySelector('#branchAutoCN_value').value;
                modBussService.bankBranchCNOut(branchAutoVal, Model, $scope);
            }

            // 失去焦点事件
            function bankBranchFocusOutEN() {
                // 获取branchAuto 的值
                var branchAutoVal = document.querySelector('#branchAutoEN_value').value;
                modBussService.bankBranchENOut(branchAutoVal, Model, $scope);
                changeBankInfoEN();
            }


            //离岸的也用这个，新增字段hCity和branchAddress不涉及验证
            function showSearchDlg(isCN) {
                var suffix = isCN ? "CN" : "EN";
                return function () {
                    bankSelectService.showSearchDlg({
                        callBack: function (branch) {
                            modBussService.setBankForBussiness(branch, Model, isCN, $scope);
                        },
                        initBranchNumber: isCN ? Model['bankInfo' + suffix].branchNumber : null,
                        initswiftCode: !isCN ? Model['bankInfo' + suffix].swiftCode : null,
                        isCN: isCN,
                        country: !Model['bankInfo' + suffix].country ? 'CN' : Model['bankInfo' + suffix].country.key,
                        countryName: !Model['bankInfo' + suffix].country ? '中国' : Model['bankInfo' + suffix].country.value
                    });
                }
            }

            function fetchBankList() {
                if (Model.bankInfoEN && Model.bankInfoEN.country && ((angular.isString(Model.bankInfoEN.country) && Model.bankInfoEN.country != 'CN') || (!angular.isString(Model.bankInfoEN.country) && Model.bankInfoEN.country.key != 'CN'))) {
                    OpenUp.getBankList({req: {countryAlpha2Code: angular.isString(Model.bankInfoEN.country) ? Model.bankInfoEN.country : Model.bankInfoEN.country.key}}).then(function (res) {
                        Model.bankENs = [];
                        if (res && res.bankList) {
                            res.bankList.sort(AUI.BaseJSUtil.arrObjCompare('bankName'));
                            for (var i = 0; i < res.bankList.length; i++) {
                                Model.bankENs.push({
                                    key: res.bankList[i].bankName,
                                    value: res.bankList[i].bankName,
                                    bankNumber: res.bankList[i].bankNumber
                                });
                            }
                        }
                        //只有离岸使用的变量
                        initController = false;
                    });
                } else {
                    Model.bankENs = sysParamCfg.bankENs;
                }
            }

            //如果是离岸银行则查询银行规则
            function getOffSiteBankRules(country, callback) {
                if (country && country != 'CN') {
                    tenantsService.getBankRuleByCountry(country, mainCons.modUserinfoConstant).then(function (merchantCfg) {
                        //获取规则
                        $scope.selectCountryCfg = merchantCfg.countryBankCfg[country];
                        if (Model.bankInfoEN && oldBankInfoEN && oldBankInfoEN.currency) {
                            $scope.selectCountryCfg.accountType.showFlag && (Model.bankInfoEN.accountType = 'SAVINGS');
                            //保留币种国家和账户,确认函不动
                            var bankAcctName = oldBankInfoEN.bankAcctName;
                            var currency = oldBankInfoEN.currency;
                            var countryObj = angular.copy(Model.bankInfoEN.country);
                            Model.bankInfoEN = {};
                            Model.isShowUpdateBankEN = false;
                            Model.bankInfoEN.bank = {key: '', value: ''};
                            Model.bankInfoEN.branch = {key: '', value: ''};
                            Model.bankInfoEN.bankAcctName = bankAcctName;//账户名称 只读 所以不变
                            Model.bankInfoEN.currency = currency;//更换国家需要带入币种
                            Model.bankInfoEN.country = countryObj;//国家保留
                            $scope.initBranchValueEN = '';
                        }
                        callback && callback(true);
                    }, function () {
                    });
                } else {
                    callback && callback(false);
                }
            }


            //离岸银行处理字段，页面加载时判断是否可编辑，后台数据不合法可编辑
            function setState4Init(bankInfo) {
                if (!Model.isAudting && bankInfo && bankInfo.country.key != 'CN') {
                    modBussService.getFieldValueForCfg('swiftCode', bankInfo.swiftCode, $scope);
                    modBussService.getFieldValueForCfg('bankNumber', bankInfo.bankNumber, $scope);
                    modBussService.getFieldValueForCfg('branchNumber', bankInfo.branchNumber, $scope);
                }
            }

            //iban特殊处理,去掉2位国家简码
            function getIban4Init(bankInfo) {
                if (bankInfo && bankInfo.iban && bankInfo.iban.length >= 2 && bankInfo.country.key != 'CN') {
                    Model.bankInfoEN.iban = bankInfo.iban.substring(2);
                } else {
                    Model.bankInfoEN.iban = bankInfo.iban;
                }
                bankInfo.ibanConfirm = bankInfo.iban;
            }

            //iban,accountnumber字段失去焦点重新使用backgroundReg校验
            function checkByServer4Blur(field) {
                var fieldCfg = $scope.selectCountryCfg[field];
                if (fieldCfg && fieldCfg.showFlag) {
                    //如果显示了校验失败
                    if (fieldCfg.showError) {
                        fieldCfg.showError = !tenantsService.validateField(Model.bankInfoEN, fieldCfg);
                    }
                }
            }

            function changeBankInfoCN() {
                $scope.isBankCNChanged = modBussService.changeBankInfoCN(Model, oldBankInfoCN, Model.bankInfoCN);
                isGreeOrGray();
                return $scope.isBankCNChanged;
            }

            function changeBankInfoEN() {
                $scope.isBankENChanged = modBussService.changeBankInfoEN(Model, oldBankInfoEN, Model.bankInfoEN);
                isGreeOrGray();
                return $scope.isBankENChanged;
            }

            //离岸银行是否改变
            function changeBankInfoOffSite() {
                $scope.isBankENChanged = modBussService.changeBankInfoOffSite(Model, oldBankInfoEN);
                isGreeOrGray();
                return $scope.isBankENChanged;
            }

            function changeTax() {
                $scope.isTaxChanged = modBussService.changeTax(oldTaxInfo, Model.taxInfo);
                isGreeOrGray();
                return $scope.isTaxChanged;
            }

            function changeContract() {
                $scope.isContractorChanged = modBussService.changeContract(oldContactor, Model.contactorInfo);
                isGreeOrGray();
                return $scope.isContractorChanged;
            }

        }]);
});

